import { Box, Typography } from "@mui/material"
import AboutCarousel from "../../components/frontView/AboutCarousel"
import CmInfo from "../../components/frontView/CmInfo"
import { motion } from "framer-motion";
import { useEffect } from "react";

const AboutCM = () => {
    useEffect(()=>{
        window.scrollTo(0,0)
    },[])
  return (
    <Box sx={{ width: '100%', minHeight: '100vh', backgroundColor: "#1a5b8e", overflow: 'hidden' }}>
        <Box sx={{ mt: 10, mb: 3 }}>
            <motion.div
                initial={{ y: -10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 10, opacity: 0 }}
                transition={{ duration: 0.2, delay: 0.3 }}
            >
                <Typography
                    sx={{
                    fontSize: '24px',
                    fontStyle: 'italic',
                    color: "#fff",
                    fontFamily: 'Racing Sans One',
                    letterSpacing: '1px',
                    ml: 1,
                    textAlign: 'center'
                    }}
                >
                    CMJ အကြောင်း

                </Typography>
            </motion.div>
            <Box sx={{ maxWidth: { xs: 500, md: 1000}, mx: 'auto', mt: 3 }}>
                <motion.div
                    initial={{ y: -10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 10, opacity: 0 }}
                    transition={{ duration: 0.2, delay: 0.5 }}
                >
                    <Typography
                        sx={{
                            color: '#fff',
                            fontSize: { xs: '0.7rem', md: '1.2rem' },
                            textAlign: 'center',
                            // textIndent: '50px',
                            px: { xs: 2, md: 0 },
                        }}
                    >
                    ဂျပန်နိုင်ငံရှိ မြန်မာလူမျိုး အလုပ်သင်၊ ကျွမ်းကျင်၊ work visa၊ Katudo ဗီဇာ ကိုင်ဆောင်ထားသူများအတွက် ကိုက်ညီသောအလုပ်အကိုင်များ ရှာဖွေတွေ့ရှိနိုင်ရန်နှင့် လိုအပ်သောကူညီဆောင်ရွက်မှုများ လုပ်ဆောင်ရန်အတွက် အခမဲ့ဆောင်ရွက်ပေးသော မြန်မာလူမျိုး ပိုင်ဆိုင်သည့် ကုမ္ပဏီဖြစ်ပါသည်။

                    </Typography>
                </motion.div>
            </Box>
        </Box>
        <AboutCarousel/>
        <CmInfo/>
    </Box>
  )
}

export default AboutCM
